<div class="mini-cart">
  <div *ngIf="cartService.getCartProducts().length === 0">
    <h5>Your cart is empty</h5>
  </div>
  <div *ngIf="cartService.getCartProducts().length > 0" class="mini-cart-inner">
    <ul [ngClass]="['mini-cart-list', cartService.getCartProducts().length === 1 ? 'slider-height_1' :  cartService.getCartProducts().length === 2 ? 'slider-height_2' : 'slider-height']">
      <li *ngFor="let item of cartService.getCartProducts()">
        <div class="cart-img f-left">
           <!-- {{ item | json}}
            -->
          <a [routerLink]="['/shop/product', item.id]">
            <img [src]="(item.product_image)?item.path+item.product_image:'assets/img/shop/product/product_1.png'" alt="cart-img" width="50" />
          </a>
        </div>
        <div class="cart-content f-left text-left">
          <h5>
            <a [routerLink]="['/shop/product', item.id]">{{item.title}}</a>
          </h5>
          <div class="cart-price">
            <span class="ammount">{{item.orderQuantity}} <i class="fal fa-times mx-1"></i></span>
            <span class="price">$ {{item.sale_price.toFixed(2)}}</span>
          </div>
        </div>
        <div class="del-icon f-right mt-30">
          <a (click)="cartService.removeCartProduct(item)" class="cursor-pointer">
            <i class="fal fa-times"></i>
          </a>
        </div>
      </li>
    </ul>
    <div class="total-price d-flex justify-content-between mb-30">
      <span>Subtotal:</span>
      <span>₹{{(cartService.totalPriceQuantity().total).toFixed(2)}}</span>
    </div>
    <div class="checkout-link">
      <a routerLink="/shop/cart" class="os-btn">view Cart</a>
      <a class="os-btn os-btn-black" routerLink="/checkout">Checkout</a>
    </div>
  </div>
</div>
